import React, { useState, useEffect } from "react"

export default function ColorsManager() {
  const [colorSchemes, setColorSchemes] = useState([])
  const [loading, setLoading] = useState(true)
  const [saved, setSaved] = useState({})

  useEffect(() => {
    fetchColorSchemes()
  }, [])

  const fetchColorSchemes = async () => {
    try {
      const response = await fetch("/api/admin/presenter_color_schemes")
      if (response.ok) {
        const data = await response.json()
        setColorSchemes(data)
      } else {
        console.error("Failed to fetch color schemes:", response.status)
      }
    } catch (error) {
      console.error("Error fetching color schemes:", error)
    } finally {
      setLoading(false)
    }
  }

  const updateLocal = (id, field, value) => {
    setColorSchemes(prev => prev.map(s => s.id === id ? { ...s, [field]: value } : s))
  }

  const save = async (scheme) => {
    try {
      const response = await fetch(`/api/admin/presenter_color_schemes/${scheme.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        },
        body: JSON.stringify({ presenter_color_scheme: { bg_color: scheme.bg_color, text_color: scheme.text_color } }),
      })

      if (response.ok) {
        setSaved(prev => ({ ...prev, [scheme.id]: true }))
        setTimeout(() => setSaved(prev => ({ ...prev, [scheme.id]: false })), 1500)
      } else {
        console.error("Failed to save color scheme")
      }
    } catch (error) {
      console.error("Error saving color scheme:", error)
    }
  }

  if (loading) return <div className="text-center py-8">Loading...</div>

  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-800 mb-6">Slide Color Schemes</h2>
      <p className="text-sm text-gray-500 mb-6">
        Changes are reflected on the audience display within 3 seconds.
      </p>

      {colorSchemes.length === 0 ? (
        <p className="text-gray-500 italic">No color schemes found. Run <code>rails db:seed</code> to create defaults.</p>
      ) : (
        <div className="bg-white border border-gray-200 rounded-lg divide-y divide-gray-200">
          {colorSchemes.map(scheme => (
            <div key={scheme.id} className="flex items-center gap-6 p-6 flex-wrap">
              <span className="w-24 font-semibold text-gray-800">{scheme.presenter_name}</span>

              <label className="flex items-center gap-2 text-sm text-gray-600">
                Background
                <input
                  type="color"
                  value={scheme.bg_color}
                  onChange={e => updateLocal(scheme.id, 'bg_color', e.target.value)}
                  className="w-10 h-10 cursor-pointer rounded border border-gray-300"
                />
              </label>

              <label className="flex items-center gap-2 text-sm text-gray-600">
                Text
                <input
                  type="color"
                  value={scheme.text_color}
                  onChange={e => updateLocal(scheme.id, 'text_color', e.target.value)}
                  className="w-10 h-10 cursor-pointer rounded border border-gray-300"
                />
              </label>

              <div
                className="px-6 py-2 rounded border border-gray-300 text-sm font-semibold min-w-32 text-center"
                style={{ backgroundColor: scheme.bg_color, color: scheme.text_color }}
              >
                {scheme.presenter_name}
              </div>

              <button
                onClick={() => save(scheme)}
                className={`px-4 py-2 text-sm font-semibold rounded transition-colors ${
                  saved[scheme.id]
                    ? 'bg-green-500 text-white'
                    : 'bg-cyan-500 hover:bg-cyan-600 text-white'
                }`}
              >
                {saved[scheme.id] ? 'Saved!' : 'Save'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
